export const config = {
    //apiUrl: 'http://localhost/api/public/index.php', 
    //backendUrl: 'http://localhost/apps/admision/ad_matricula_be', 
    apiUrl: 'https://api.cftestataltarapaca.cl', 
    backendUrl: 'https://apps.cftestataltarapaca.cl/admision/ad_prematricula_be',
};